export default __webpack_public_path__ + "static/media/Fest Section 1 mobile.f0562406.jpg";